//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        submitUrl: {
            type: String,
            default: '/settle/settBill/add',
        },
        successUrl: {
            type: String,
            default: '/settle/order/list-settle',
        },
    },
    data: function () {
        return {
            form: {
                billName: '',
                remark: '',
            },
        };
    },
    methods: {
        cancle: function () {
            this.$emit('close');
        },
        submit() {
            this.$post(
                `${this.$store.getters.indexUrl}${this.submitUrl}`,
                {
                    ...this.form,
                    settleOrderList: this.data.map((item) => {
                        return {
                            orderId: item.orderId,
                        };
                    }),
                    projectSettleList: this.data.map((item) => {
                        return {
                            productId: item.productId,
                            projectCode: item.projectCode,
                        };
                    }),
                },
                (data) => {
                    this.cancle();
                    ShowMsg('申请成功', 'success');

                    this.goto(this.successUrl);
                },
                true
            );
        },
    },
    mounted() {},
};
